import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isBootFeatureEnabled } from 'owa-metatags/lib/isBootFeatureEnabled';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const newHeaderCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // This capability is enabled by default
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return isBootFeatureEnabled('fwk-new-monarch-header');
    },
};
